import {
  object,
  string,
  optional,
  type InferInput,
  picklist,
  boolean,
  array,
} from "valibot";
import { fetcher } from "../fetcher";
import { CurrencyCode } from "./schema/CurrencyCode";

const headers =
  import.meta.env.VITE_ENVIRONMENT === "production"
    ? {
        "r2r-canonical-url": window.location.href,
      }
    : undefined;

export async function configs({
  uid,
  aqid,
  debugFeatures,
  debugExperiments,
  flags,
  referer,
}: {
  uid?: string;
  aqid?: string;
  debugFeatures?: string;
  debugExperiments?: string;
  flags?: string;
  referer?: string;
}): Promise<ConfigsResponse> {
  return fetcher("/api/1.6/configs", {
    schema: ConfigsResponse,
    query: {
      uid,
      aqid,
      debugFeatures: debugFeatures || undefined,
      debugExperiments: debugExperiments || undefined,
      flags: flags || undefined,
      referer: referer,
      useFeatureMap: true,
    },
    headers,
  });
}

export type ConfigsResponse = InferInput<typeof ConfigsResponse>;
export const ConfigsResponse = object({
  uid: string(),
  aqid: string(),
  requestId: string(),
  experimentConfig: string(),
  botName: string(),
  currencyCode: CurrencyCode,
  distanceUnit: picklist(["km", "mi"]),
  clockType: picklist(["clock24", "clock12"]),
  hotelProvider: optional(string()),
  featureFlags: array(object({ featureName: string(), isEnabled: boolean() })),
  encodedFeatureString: optional(string()),
});
